import React from 'react';

const SvgVehicleAdd = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 42 42" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>>
    <title>{title}</title>
    <path
      fill="currentColor"
      d="M26.944 7.887H8.531L5.073 17.96h34.684a47.09 47.09 0 0 0 .97 2.585v13.9l-.033 4.598c0 1.276-1.04 2.417-2.316 2.417H36.33c-1.276 0-2.317-1.275-2.317-2.551v-4.163H7.154v4.163c0 1.276-1.007 2.551-2.283 2.551H2.79c-1.275 0-2.317-1.141-2.317-2.417L.44 20.545l4.8-13.8C5.746 5.404 6.987 4.53 8.53 4.53h18.414zM7.154 28.032a3.367 3.367 0 0 0 3.358-3.358 3.367 3.367 0 0 0-3.358-3.357 3.367 3.367 0 0 0-3.357 3.357 3.367 3.367 0 0 0 3.357 3.358zm26.86 0a3.367 3.367 0 0 0 3.356-3.358 3.367 3.367 0 0 0-3.357-3.357 3.367 3.367 0 0 0-3.357 3.357 3.367 3.367 0 0 0 3.357 3.358z"
    />
    <path fill="currentColor" d="M41.85 4.64h-4.64V0h-3.04v4.64h-4.64v3.04h4.64v4.64h3.04V7.68h4.64z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgVehicleAdd svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/VehicleAdd.js